/* eslint-disable @typescript-eslint/no-explicit-any */
// Ref: https://github.com/sidebase/nuxt-auth/blob/main/src/runtime/middleware/auth.ts
export default defineNuxtRouteMiddleware((to) => {
  const metaAuth: any = typeof to.meta.auth === 'object'
    ? {
        unauthenticatedOnly: true,
        ...to.meta.auth,
      }
    : to.meta.auth

  if (metaAuth === false) {
    return
  }

  const authConfig = Object(useRuntimeConfig().public.auth)
  const { status, refresh, refreshToken } = useAuth()
  const isGuestMode = typeof metaAuth === 'object' && metaAuth.unauthenticatedOnly
  const logger = useCanxLogger()

  // Guest mode happy path 1: Unauthenticated user is allowed to view page
  if (isGuestMode && status.value === 'unauthenticated') {
    return
  }
  if (status.value === 'unauthenticated' && refreshToken.value) {
    return refresh().catch(() => {
      try {
        return useFirebase().unregister().catch(() => {})
      }
      catch (e) {
        logger.error('Error unregistering firebase service worker', undefined, e as Error)
      }
    })
      .then(async () => navigateTo((authConfig.provider as any).pages.login))
  }

  // Guest mode edge-case: Developer used guest-mode config style but set `unauthenticatedOnly` to `false`
  if (typeof metaAuth === 'object' && !metaAuth.unauthenticatedOnly) {
    return
  }

  if (status.value === 'authenticated') {
    // Guest mode happy path 2: Authenticated user should be directed to another page
    if (isGuestMode) {
      return navigateTo(metaAuth.navigateAuthenticatedTo ?? '/')
    }
    return
  }

  /**
   * We do not want to enforce protection on `404` pages (unless the user opts out of it by setting `allow404WithoutAuth: false`).
   *
   * This is to:
   * - improve UX and DX: Having to log-in to see a `404` is not pleasent,
   * - avoid the `Error [ERR_HTTP_HEADERS_SENT]`-error that occurs when we redirect to the sign-in page when the original to-page does not exist. Likely related to https://github.com/nuxt/framework/issues/9438
   *
   */
  const globalAppMiddleware = authConfig.globalAppMiddleware
  if (globalAppMiddleware === true || (typeof globalAppMiddleware === 'object' && globalAppMiddleware.allow404WithoutAuth)) {
    const matchedRoute = to.matched.length > 0
    if (!matchedRoute) {
      // Hands control back to `vue-router`, which will direct to the `404` page
      return
    }
  }

  if (typeof metaAuth === 'object' && metaAuth.navigateUnauthenticatedTo) {
    return navigateTo(metaAuth.navigateUnauthenticatedTo)
  }
  return navigateTo((authConfig.provider as any).pages.login) // Use the ProviderRefresh type
})
